export default "__VITE_ASSET__DOVeJujf__"